import { put, call, takeLatest } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { fetchUser } from '../../../containers/AdminPanel/features/users/usersAPI';
import { SHOW_TOAST_WITH_PROPS } from "@/common/actionConstants";

export function* updateProfilePhoneNumber({payload}){
    try {
        yield put({ type:  ActionConstants.SET_UPDATING_DATA, payload: {key: 'phone'} });
        const { status } = yield call(Api.updateProfilePhoneApi, ActionConstants.UPDATE_PHONE_NUMBER, payload);
        if (status == 200) {
            yield put({ type: ActionConstants.UPDATE_USER_INFO_SUCCESS, payload: payload });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally { 
        yield put({ type:  ActionConstants.SET_UPDATING_DATA, payload: {key: null} });
    }
}

export function* updateUserData({ payload }) {
    try {
        yield put({ type: ActionConstants.SET_UPDATING_DATA, payload: { key: 'name' } });
        const { status } = yield call(Api.updateUser, payload);

        if (status) {
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: {
                    message: "User data updated successfully.",
                    type: "success",
                    delayTime: 8000,
                    autoClose: true
                }
            });
        } else {
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: {
                    message: "Failed to update user data.",
                    type: "error",
                    delayTime: 8000,
                    autoClose: true
                }
            });
        }
    } catch (error) {
        console.log(error);
    } finally {
        yield put({ type: ActionConstants.SET_UPDATING_DATA, payload: { key: null } });
    }
}

export function* updateAUSettings({payload}){
    try {
        // yield put({ type: SHOW_LOADER });
        const { status } = yield call(Api.updateAUSettings, ActionConstants.UPDATE_AU_SETTINGS, payload);
        if (status == 200) {
            yield put({ type: ActionConstants.UPDATE_AU_SETTINGS_SUCCESS, payload: payload });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally { 
        // yield put({ type: HIDE_LOADER });
    }
}

export function* getNotificationSettings(){
    try {
        const response = yield call(Api.getNotificationSettings, ActionConstants.GET_NOTIFICATION_SETTINGS);
        if (response && !response.message) {
            yield put({ type: ActionConstants.GET_NOTIFICATION_SETTINGS_SUCCESS, payload: response });
        } else {
            yield put({ type: ActionConstants.GET_NOTIFICATION_SETTINGS_FAILURE, payload: response });
        }
    }
    catch (error) {
        console.log(error)
        yield put({ type: ActionConstants.GET_NOTIFICATION_SETTINGS_FAILURE, payload: error });
    }
}

export function* updateNotificationSettings({payload}){
    try {
        const response = yield call(Api.updateNotificationSettings, ActionConstants.UPDATE_NOTIFICATION_SETTINGS, payload);
        if (response && !response.message) {
            yield put({ type: ActionConstants.UPDATE_NOTIFICATION_SETTINGS_SUCCESS, payload: response });
        } else {
            yield put({ type: ActionConstants.UPDATE_NOTIFICATION_SETTINGS_FAILURE, payload: response });
        }
    }
    catch (error) {
        console.log(error)
        yield put({ type: ActionConstants.UPDATE_NOTIFICATION_SETTINGS_FAILURE, payload: error });
    }
}

export function* updateTimeZone({payload}){
    try {
        yield put({ type:  ActionConstants.SET_UPDATING_DATA, payload: {key: 'timezone'} });
        const callback= payload.callback;
        const mode=payload.mode;
        const timeZoneValue=payload.timeZoneValue;
        delete payload.timezoneValue;
        delete payload.callback;
        delete payload.mode;
        const { status } = yield call(Api.updateTimeZone, ActionConstants.UPDATE_TIME_ZONE, payload);
        if (status == 200) {
            callback();
            yield put({ type: ActionConstants.UPDATE_USER_INFO_SUCCESS, payload: Object.assign({},payload,{mode:mode, timezoneValue:timeZoneValue}) });          
        }
    }
    catch (error) {
        console.log(error)
    }
    finally {
        yield put({ type:  ActionConstants.SET_UPDATING_DATA, payload: {key: null} });   
    }
}

export function* createUserLicense({payload}) {
    try {
        const callback= payload.callback;
        const errorCallback= payload.errorCallback;
        delete payload.callback;
        delete payload.errorCallback;
        const { status, licenseInfo, error } = yield call(Api.createUserLicense, ActionConstants.CREATE_USER_LICENSE, [payload]);
        if (status == 200) {
            callback();
            yield put({ type: ActionConstants.CREATE_USER_LICENSE_SUCCESS, payload: licenseInfo });          
        } else {
            if(error){
                errorCallback(error);
            }            
        }
    }
    catch (error) {
        console.log(error)
    }
}

export function* updateUserLicense({payload}) {
    try {    
        const callback= payload.callback;
        const errorCallback= payload.errorCallback;
        delete payload.callback;
        delete payload.errorCallback;   
        const { status, licenseInfo, error } = yield call(Api.updateUserLicense, ActionConstants.UPDATE_USER_LICENSE, [payload]);
        if (status == 200) {            
            yield put({ type: ActionConstants.UPDATE_USER_LICENSE_SUCCESS, payload: licenseInfo });
            callback();
        } else {
            if(error){
                errorCallback(error);
            }            
        }
    }
    catch (error) {
        console.log(error)
    }
}

export function* deleteUserLicense({payload}) {
    try {       
        const { status } = yield call(Api.deleteUserLicense, ActionConstants.DELETE_USER_LICENSE, payload);
        if (status == 200) {            
            yield put({ type: ActionConstants.DELETE_USER_LICENSE_SUCCESS, payload: payload });          
        }
    }
    catch (error) {
        console.log(error)
    }
}

export function* getUserList({payload}){
    try {
        const response = yield call(fetchUser, { userId: payload });
        if(response && !response.error && !response.Error) {
            yield put({ 
                type: ActionConstants.GET_MANAGE_PROFILE_SUCCESS, 
                payload: response
            });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally {
    }
}

export default [
    takeLatest(ActionConstants.UPDATE_PHONE_NUMBER , updateProfilePhoneNumber),
    takeLatest(ActionConstants.UPDATE_USER_DATA,updateUserData),
    takeLatest(ActionConstants.UPDATE_AU_SETTINGS, updateAUSettings),
    takeLatest(ActionConstants.GET_NOTIFICATION_SETTINGS, getNotificationSettings),
    takeLatest(ActionConstants.UPDATE_NOTIFICATION_SETTINGS, updateNotificationSettings),
    takeLatest(ActionConstants.UPDATE_TIME_ZONE, updateTimeZone),
    takeLatest(ActionConstants.CREATE_USER_LICENSE, createUserLicense),
    takeLatest(ActionConstants.UPDATE_USER_LICENSE, updateUserLicense),
    takeLatest(ActionConstants.DELETE_USER_LICENSE, deleteUserLicense),
    takeLatest(ActionConstants.GET_USER_INFO, getUserList)
]

